// Campaign selector for the Video QC page (searchable), with the selected
// campaign's dates and status beside it.
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { C, Pill, SURFACE } from './ui';

const STATUS_PILL = {
    active: { bg: '#dcfce7', color: '#166534' },
    draft: { bg: '#f3f4f6', color: '#374151' },
    completed: { bg: '#e0e7ff', color: '#3730a3' },
    archived: { bg: '#f3f4f6', color: '#6b7280' },
};

const fmtDate = (d) => {
    const date = d ? new Date(d) : null;
    return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : null;
};

export default function CampaignPicker({ campaigns, loading, selected, onSelect }) {
    const status = String(selected?.status || '').toLowerCase();
    const pill = STATUS_PILL[status];
    const dates = [fmtDate(selected?.startDate), fmtDate(selected?.endDate)].filter(Boolean).join(' – ');

    return (
        <div style={{ ...SURFACE, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
            <Autocomplete
                className="vqc-picker"
                sx={{ width: 420, maxWidth: '100%' }}
                options={campaigns}
                loading={loading}
                value={selected || null}
                onChange={(_, campaign) => campaign && onSelect(campaign)}
                getOptionLabel={(c) => c.name || `Campaign ${c.id}`}
                renderOption={(props, c) => (
                    <li {...props} key={c.id}>
                        <span style={{ flex: 1 }}>{c.name}</span>
                        {c.brand && <span style={{ fontSize: 12, color: C.muted, marginLeft: 12 }}>{c.brand}</span>}
                    </li>
                )}
                isOptionEqualToValue={(a, b) => String(a.id) === String(b.id)}
                noOptionsText="No campaigns found"
                renderInput={(params) => (
                    <TextField {...params} label="Campaign" placeholder="Search campaigns" size="small"
                        InputProps={{ ...params.InputProps, startAdornment: <CampaignOutlinedIcon style={{ color: C.muted, fontSize: 19, marginLeft: 4 }} /> }} />
                )}
            />
            {selected && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, color: C.muted, flexWrap: 'wrap' }}>
                    {pill && <Pill bg={pill.bg} color={pill.color} style={{ textTransform: 'capitalize' }}>{status}</Pill>}
                    {selected.brand && <span style={{ fontWeight: 600, color: C.text }}>{selected.brand}</span>}
                    {dates && <span>{dates}</span>}
                    {selected.objective && <span style={{ color: C.body }}>{selected.objective}</span>}
                </div>
            )}
        </div>
    );
}
